import api from "../axios";

export interface CartShareItem {
  productId: string;
  quantity: number;
}

export const cartShareService = {
  getItems: async (shortId: string): Promise<{ items: CartShareItem[] }> => {
    const response = await api.get(`/cart-share/${shortId}`);
    return response.data;
  },
  
  create: async (items: CartShareItem[]): Promise<{ shortId: string }> => {
    const response = await api.post('/cart-share', { items });
    return response.data;
  }
};
